<template>
  <v-container class="container">
    <v-card>
      <v-card-title font-weight-bold
        >Formulario envío de multas a TGR</v-card-title
      >

      <v-card-text class="mt-3">
        <v-divider />
        <v-form ref="form" v-model="valid">
          <h5 font-weight-bold>Dato Electorales</h5>
          <v-divider />
          <div>
            <v-row>
              <v-col cols="4">
                <v-select
                  v-model="formMulta.id_tipoeleccion"
                  :items="tipoelEcciones"
                  item-value="id"
                  item-text="name"
                  label="Tipo Elección"
                  outlined
                  :rules="[required]"
                  dense
                />
              </v-col>
              <v-col cols="4">
                <v-menu
                  ref="fechaEleccion"
                  v-model="showFechaEvento"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  dense
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :rules="[
                        (v) =>
                          formMulta.tipoeleccion == 0 ||
                          !!v ||
                          'El campo es requerido cuando tipo de eleccion no es 0',
                      ]"
                      v-model="formMulta.fechaevento"
                      label="Fecha de la Elección"
                      persistent-hint
                      append-icon="mdi-calendar"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formMulta.fechaevento"
                    no-title
                    @input="showFechaEvento = false"
                    dense
                  ></v-date-picker> </v-menu
              ></v-col>
              <v-col cols="4">
                <v-select
                  v-model="formMulta.id_tipoevento"
                  :items="tipoEventos"
                  item-value="id"
                  item-text="name"
                  label="Tipo Evento"
                  outlined
                  :rules="[required]"
                  dense
                />
              </v-col>
            </v-row>
          </div>
          <h5 font-weight-bold>Datos del Infractor</h5>
          <v-divider />
          <div>
            <v-row>
              <v-col cols="6">
                <v-row class="flex-nowrap">
                  <v-col cols="8">
                    <v-text-field
                      :rules="[
                        required,
                        (v) =>
                          /^[0-9]{1,10}$/.test(v) ||
                          'Debe ser un entero de hasta 10 caracteres',
                      ]"
                      v-model="formMulta.rut"
                      label="Rut"
                      type="Number"
                      outlined
                      dense
                    />
                  </v-col>

                  <v-col>
                    <v-text-field
                      :rules="[
                        required,
                        (v) =>
                          /^([0-9K]){1}$/.test(v.toUpperCase()) ||
                          'Debe ser 0-9, K',
                      ]"
                      v-model="formMulta.dv"
                      label="DV"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :rules="[
                    (v) =>
                      v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                  ]"
                  v-model="formMulta.nombres"
                  label="Nombres"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :rules="[
                    required,
                    (v) =>
                      v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                      ]"
                  v-model="formMulta.paterno"
                  label="Rs o apellido paterno"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :rules="[
                    (v) =>
                      v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                  ]"
                  v-model="formMulta.materno"
                  label="Apellido materno"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :rules="[
                    (v) =>
                      /^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,4}$/.test(v) ||
                      'Ingrese un correo electrónico válido',
                  ]"
                  v-model="formMulta.email"
                  label="Correo electronico"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="formMulta.telefono"
                  :rules="[
                    (v) =>
                      /^[0-9]{1,11}$/.test(v) ||
                      'Debe ser un entero de hasta 11 caracteres',
                  ]"
                  type="Number"
                  label="Telefono"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </div>
          <h5>Dirección</h5>
          <v-divider />
          <div>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="formMulta.comuna"
                  label="comuna"
                  outlined
                  :items="comunas"
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="formMulta.calle"
                  :rules="[
                    (v) => v.length <= 55 || 'Debe ser de hasta 55 caracteres',
                  ]"
                  label="Nombre calle"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="formMulta.block"
                  :rules="[
                    (v) =>
                      v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                  ]"
                  label="block"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="formMulta.villa"
                  :rules="[
                    (v) =>
                      v.length <= 200 || 'Debe ser de hasta 200 caracteres',
                  ]"
                  label="villa"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="formMulta.oficina"
                  :rules="[
                    (v) => v.length <= 15 || 'Debe ser de hasta 15 caracteres',
                  ]"
                  label="oficina/depto"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </div>
          <h5>Datos de la Multa</h5>
          <v-divider />
          <div>
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  v-model="motivoSelected"
                  :items="motivosTipoMoneda"
                  :item-text="(item) => `${item.motivo}  ${item.articulo}`"
                  label="Motivo de la Multa"
                  :rules="[required]"
                  outlined
                  return-object
                  search
                  @change="motivoChange()"
                />
              </v-col>

              <v-col cols="4">
                <v-text-field
                  :rules="[
                    required,
                    (v) =>
                    /^\d{1,14}(\.\d{4})?$/.test(v) ||
                      'Debe tener hasta 14 caracteres y 4 decimales',
                  ]"
                  v-model="formMulta.montomulta"
                  label="Monto"
                  outlined
                  type="Number"
                  :suffix="formMulta.moneda"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-menu
                  ref="fechaEmision"
                  v-model="showFechaEmision"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  dense
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :rules="[required]"
                      v-model="formMulta.fechaemision"
                      label="Fecha de Emisión de la multa"
                      persistent-hint
                      append-icon="mdi-calendar"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formMulta.fechaemision"
                    no-title
                    @input="showFechaEmision = false"
                    dense
                  ></v-date-picker> </v-menu
              ></v-col>
              <v-col cols="4">
                <v-menu
                  ref="fechaVencimiento"
                  v-model="showFechavencimiento"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  dense
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :rules="[required]"
                      v-model="formMulta.vencimiento"
                      label="Fecha de Vencimiento"
                      persistent-hint
                      append-icon="mdi-calendar"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formMulta.vencimiento"
                    no-title
                    @input="showFechavencimiento = false"
                    dense
                  ></v-date-picker> </v-menu
              ></v-col>
            </v-row>
            <v-row> </v-row>
          </div>
          <div>
            <v-row>
              <v-col cols="6">
                <v-btn @click="clearData()" class="mr-2">Borrar campos</v-btn>
              </v-col>
              <v-col cols="6" d-flex class="justify-right">
                <v-btn
                  :disabled="!validFormBtn"
                  color="primary"
                  @click="sendMulta()"
                  >Enviar Multa
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import comunas from "@/util/comunas";
import motivos from "@/util/motivostipomoneda";
import { MultasService } from "../../util/Api/Multas/calls";
import { Loading } from "element-ui";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
export default {
  name: "MultaComponents",
  components: {
  },
  data() {
    return {
      valid: null,
      required: (v) => !!v || "El campo es requerido",
      comunas: [],
      motivosTipoMoneda:[],
      motivoSelected:null,
      tipoelEcciones: [
        { id: 0, name: "Sin Elección" },
        { id: 1, name: "Presidente" },
        { id: 2, name: "Senadores" },
        { id: 3, name: "Diputados" },
        { id: 4, name: "Alcaldes" },
        { id: 5, name: "Concejales" },
        { id: 6, name: "Consejeros Regionales" },
        { id: 7, name: "Gore " },
        { id: 9, name: "Consejero Constitucional" },
      ],
      tipoEventos:[
        { id: 0, name: "No Aplica " },
        { id: 1, name: "Precandidatura" },
        { id: 2, name: "Primaria" },
        { id: 3, name: "Definitiva" },
        { id: 4, name: "Segunda Votacion" },
      ],
      showFechaEvento:false,
      showFechaEmision:false,
      showFechavencimiento:false,
      formMulta: {
            dv: "",
            rut: "",
            block: "",
            calle: "",
            email: "",
            villa: "",
            comuna: "",
            moneda: null,
            motivo: null,
            materno: "",
            nombres: "",
            paterno: "",
            oficina: "",
            telefono: "",
            montomulta: "",
            fechaevento: null,
            vencimiento: null,
            fechaemision: null,
            id_tipoevento: null,
            id_tipoeleccion: null
      },
    };
  },
  computed: {
    ...mapGetters(["getPerfil"]),

    validFormBtn() {
      return (
        !!this.formMulta.paterno &&
        !!this.formMulta.id_tipoeleccion &&
        !!this.formMulta.id_tipoevento &&
        !!this.formMulta.rut &&
        !!this.formMulta.dv &&
        !!this.formMulta.moneda &&
        !!this.formMulta.montomulta &&
        !!this.formMulta.fechaemision &&
        !!this.formMulta.vencimiento &&
        !!this.formMulta.motivo
      );
    },
  },
  mounted() {
    this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });
    this.comunas = comunas.comunas;
    this.motivosTipoMoneda= motivos.MotivosTipoMoneda;
    console.log("motivos", this.motivosTipoMoneda);


    this.loadingInstance.close();
  },
  methods: {

    motivoChange(){
      if (this.motivoSelected) {
        this.formMulta.motivo=this.motivoSelected.motivo
        this.formMulta.moneda=this.motivoSelected.moneda
      }else{
        this.formMulta.motivo=null
        this.formMulta.moneda=null
      }
    },

    clearData() {
      this.formMulta= {
            dv: "",
            rut: "",
            block: "",
            calle: "",
            email: "",
            villa: "",
            comuna: "",
            moneda: null,
            motivo: null,
            materno: "",
            nombres: "",
            paterno: "",
            oficina: "",
            telefono: "",
            montomulta: "",
            fechaevento: null,
            vencimiento: null,
            fechaemision: null,
            id_tipoevento: null,
            id_tipoeleccion: null
      }
    },

    resetForm() {
      this.$refs.form.reset();
    },

    async sendMulta() {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        console.log("userPerfil", this.getPerfil.id, this.getPerfil.subdireccion_id);

        const body = {
          idusuario: this.getPerfil.id,
          idsubdireccion: this.getPerfil.subdireccion_id,
          data: [this.formMulta],
        };

        const resp = await MultasService.send(body);
        console.log("resp", resp);
        if (resp.statusCode != 200 && resp.statusCode != 201) {
          throw resp.msg;
        }
        this.resetForm();
        this.loadingInstance.close();
        Swal.fire({ type: "success", html: `Multa Enviada` });
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al enviar la multa: ${JSON.stringify(error)}`,
        });
      }
    },
  },
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>
